import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import useMediaQuery from "@mui/material/useMediaQuery";
import DataGridSearch from "components/DataGridSearch";
import queryString from "query-string";
import { useCallback, useLayoutEffect, useState } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";

export default function AuctionsStatusesButtons() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = queryString.parse(search);
  const [value, setValue] = useState("ALL_Auctions");
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useLayoutEffect(() => {
    if (query.auctionStatus) {
      setValue(query?.auctionStatus && query.auctionStatus);
    }
    if (query.featured) {
      setValue(query.featured === "true" && "featured");
    }
  }, [query.auctionStatus, query.feature, query.featured]);

  const handleChange = useCallback(
    (_, value) => {
      setValue(value);
      // Necessary for performance
      // eslint-disable-next-line no-unused-vars
      const { auctionStatus, featured, ...rest } = query;
      let params = { ...rest };
      switch (value) {
        case "active":
          params.auctionStatus = "active";
          break;
        case "scheduled":
          params.auctionStatus = "scheduled";
          break;
        case "finished":
          params.auctionStatus = "finished";
          break;
        case "canceled":
          params.auctionStatus = "canceled";
          break;
        default:
          break;
      }
      navigate({
        pathname: "/auctions",
        search: createSearchParams(params).toString(),
      });
    },
    [navigate, query]
  );

  return (
    <Box py={1} sx={containerStyles}>
      <Box
        sx={{
          backgroundColor: "white",
          marginBottom: { xs: 2, md: 0 },
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Product status filters"
        >
          <Tab label="All Auctions" value="ALL_Auctions" />
          <Tab label="Active" value="active" />
          <Tab label="Scheduled" value="scheduled" />
          <Tab label="Finished" value="finished" />
          <Tab label="Canceled" value="canceled" />
        </Tabs>
      </Box>
      <Box display={isSmall ? "grid" : "flex"}>
        <DataGridSearch
          searchKeyParam="name"
          searchKeyParamValue="title"
          searchQueryParam="value"
        />
      </Box>
    </Box>
  );
}
const containerStyles = {
  display: { xs: "grid", md: "flex" },
  justifyContent: "space-between",
  alignItems: "baseline",
  "& .styled-button": {
    borderRadius: "1px",
    padding: "10px",
  },
  "& .MuiOutlinedInput-root": { borderRadius: "20px" },
  "& .MuiTab-root": { textTransform: "capitalize" },
};
